import { useDispatch } from 'react-redux'
import { actions as trackingActions } from 'modules/tracking/actions'
import { throttle } from 'lodash'

export const useTracking = () => {
  const dispatch = useDispatch()
  const trackEvent = (name: string, args?: Record<string, unknown>, external?: boolean) =>
    dispatch(throttle(trackingActions.trackevent(name, args, external), 500))

  return trackEvent
}
